import { lazy } from 'react';

import { RouteEnum } from '@/models/route/Route.enum.ts';
import { RouteModel } from '@/models/route/Route.model.ts';

const AttemptView = lazy(() =>
  import('@/views/attempt/Attempt.view.tsx').then(module => ({
    default: module.AttemptView,
  })),
);

const AttemptDetailsView = lazy(() =>
  import('@/views/attempts/AttemptDetails.view.tsx').then(module => ({
    default: module.AttemptDetailsView,
  })),
);

const AttemptListView = lazy(() =>
  import('@/views/attempts/AttemptList.view.tsx').then(module => ({
    default: module.AttemptListView,
  })),
);

const ExamView = lazy(() =>
  import('@/views/exam/Exam.view.tsx').then(module => ({
    default: module.ExamView,
  })),
);

const ComingSoonView = lazy(() =>
  import('@/views/comingSoon/ComingSoon.view.tsx').then(module => ({
    default: module.ComingSoonView,
  })),
);

const DictionaryManagementView = lazy(() =>
  import('@/views/dictionaryManagement/DictionaryManagement.view.tsx').then(module => ({
    default: module.DictionaryManagementView,
  })),
);

const QuestionBankView = lazy(() =>
  import('@/views/questionBank/QuestionBank.view.tsx').then(module => ({
    default: module.QuestionBankView,
  })),
);

const QuestionCreateView = lazy(() =>
  import('@/views/questionForm/QuestionCreate.view.tsx').then(module => ({
    default: module.QuestionCreateView,
  })),
);

const QuestionEditView = lazy(() =>
  import('@/views/questionForm/QuestionEdit.view.tsx').then(module => ({
    default: module.QuestionEditView,
  })),
);

const QuestionFocusView = lazy(() =>
  import('@/views/questionFocus/QuestionFocus.view.tsx').then(module => ({
    default: module.QuestionFocusView,
  })),
);

const QuestionHistoryView = lazy(() =>
  import('@/views/questionHistory/QuestionHistory.view.tsx').then(module => ({
    default: module.QuestionHistoryView,
  })),
);

const QuestionRankingView = lazy(() =>
  import('@/views/questionStatistics/QuestionRanking.view.tsx').then(module => ({
    default: module.QuestionRankingView,
  })),
);

const QuestionStatisticsView = lazy(() =>
  import('@/views/questionStatistics/QuestionStatistics.view.tsx').then(module => ({
    default: module.QuestionStatisticsView,
  })),
);

const SettingsView = lazy(() =>
  import('@/views/settings/Settings.view.tsx').then(module => ({
    default: module.SettingsView,
  })),
);

const SurveyCreateView = lazy(() =>
  import('@/views/surveys/SurveyCreate.view.tsx').then(module => ({
    default: module.SurveyCreateView,
  })),
);

const SurveyEditView = lazy(() =>
  import('@/views/surveys/SurveyEdit.view.tsx').then(module => ({
    default: module.SurveyEditView,
  })),
);

const SurveyHistoryView = lazy(() =>
  import('@/views/surveys/SurveyHistory.view.tsx').then(module => ({
    default: module.SurveyHistoryView,
  })),
);

const SurveyResponseView = lazy(() =>
  import('@/views/surveyResponse/SurveyResponse.view.tsx').then(module => ({
    default: module.SurveyResponseView,
  })),
);

const SurveyResponseDetailsView = lazy(() =>
  import('@/views/surveys/SurveyResponseDetails.view.tsx').then(module => ({
    default: module.SurveyResponseDetailsView,
  })),
);

const SurveyResponseListView = lazy(() =>
  import('@/views/surveys/SurveyResponseList.view.tsx').then(module => ({
    default: module.SurveyResponseListView,
  })),
);

const SurveyListView = lazy(() =>
  import('@/views/surveys/SurveyList.view.tsx').then(module => ({
    default: module.SurveyListView,
  })),
);

const TestCreateView = lazy(() =>
  import('@/views/tests/TestCreate.view.tsx').then(module => ({
    default: module.TestCreateView,
  })),
);

const TestEditView = lazy(() =>
  import('@/views/tests/TestEdit.view.tsx').then(module => ({
    default: module.TestEditView,
  })),
);

const TestHistoryView = lazy(() =>
  import('@/views/tests/TestHistory.view.tsx').then(module => ({
    default: module.TestHistoryView,
  })),
);

const TestListView = lazy(() =>
  import('@/views/tests/TestList.view.tsx').then(module => ({
    default: module.TestListView,
  })),
);

const MODULE_ROUTES: RouteModel[] = [
  { component: AttemptView, path: RouteEnum.ATTEMPT },
  { component: AttemptDetailsView, path: RouteEnum.ATTEMPT_DETAILS },
  { component: ExamView, path: RouteEnum.ATTEMPT_EXAM },
  { component: AttemptListView, path: RouteEnum.ATTEMPTS },
  { component: ComingSoonView, path: RouteEnum.DASHBOARD },
  { component: DictionaryManagementView, path: RouteEnum.DICTIONARIES },
  { component: ComingSoonView, path: RouteEnum.PATHS },
  { component: ComingSoonView, path: RouteEnum.PROCESSES },
  { component: QuestionBankView, path: RouteEnum.QUESTION_BANK },
  { component: QuestionCreateView, path: RouteEnum.QUESTION_CREATE },
  { component: QuestionEditView, path: RouteEnum.QUESTION_EDIT },
  { component: QuestionFocusView, path: RouteEnum.QUESTION_FOCUS },
  { component: QuestionHistoryView, path: RouteEnum.QUESTION_HISTORY },
  { component: QuestionRankingView, path: RouteEnum.QUESTION_RANKING },
  { component: QuestionStatisticsView, path: RouteEnum.QUESTION_STATISTICS },
  { component: SettingsView, path: RouteEnum.SETTINGS },
  { component: SurveyCreateView, path: RouteEnum.SURVEY_CREATE },
  { component: SurveyEditView, path: RouteEnum.SURVEY_EDIT },
  { component: SurveyHistoryView, path: RouteEnum.SURVEY_HISTORY },
  { component: SurveyResponseView, path: RouteEnum.SURVEY_RESPONSE },
  { component: SurveyResponseDetailsView, path: RouteEnum.SURVEY_RESPONSE_DETAILS },
  { component: SurveyResponseListView, path: RouteEnum.SURVEY_RESPONSES },
  { component: SurveyListView, path: RouteEnum.SURVEYS },
  { component: TestCreateView, path: RouteEnum.TEST_CREATE },
  { component: TestEditView, path: RouteEnum.TEST_EDIT },
  { component: TestHistoryView, path: RouteEnum.TEST_HISTORY },
  { component: TestListView, path: RouteEnum.TESTS },
];

export const ROUTES: RouteModel[] = import.meta.env.DEV
  ? [
      ...MODULE_ROUTES,
      {
        component: lazy(() =>
          import('@/views/devPatterns/DevPatterns.view.tsx').then(module => ({
            default: module.DevPatternsView,
          })),
        ),
        path: RouteEnum.DEV_PATTERNS,
      },
    ]
  : MODULE_ROUTES;
